import { render } from "./add-edit-correspondence-modal.html?vue&type=template&id=050b40d3&scoped=true&ts=true&external"
import script from "./add-edit-correspondence-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-correspondence-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-correspondence-modal.scss?vue&type=style&index=0&id=050b40d3&scoped=true&lang=sccs&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b40d3"]])

export default __exports__